import React from "react"
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"


const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu" style={{height: "100%"}}>
       
        <div data-simplebar className="h-100">
          <SidebarContent />
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

export default Sidebar
